import { IKnmListFilterRaw } from 'APIPackage/KnmListModule/interfaces/IKnmListFilterRaw';
import { IKnmListFilterParams } from 'APIPackage/KnmListModule/interfaces/IKnmListFilterParams';
import { KnmVersionsEnum } from 'APIPackage/KnmModule/enums/KnmVersionsEnum';
import { getStorageItem } from 'CorePackage/MainModule/common/localStore';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getLawInterface } from 'CorePackage/MainModule/reducers/coreReducer';
import { getKnmListFilterPlanNum } from 'KnmListPackage/KnmListFiltersModule/selectors/knmListFilterSelectors';

import { getKnmListSearchValue } from '../selectors/knmListSelectors';
import { getRawFilter } from './getRawFilter';

const { ERP, ERKNM } = KnmVersionsEnum;

export const getRequestFilterData = (state: IRootState, filter?: IKnmListFilterParams): IKnmListFilterParams | null => {
  const isErknm = getLawInterface(state) === LawInterfacesEnum.FZ_248;
  const isFilterOn = !!getStorageItem(StorageNamesEnum.KNM_FILTER_ON);
  const planNum = getKnmListFilterPlanNum(state);
  const version: KnmVersionsEnum = isErknm ? ERKNM : ERP;

  if (filter) {
    return isFilterOn && filter ? { ...filter, version } : null;
  }
  const rawFilter: IKnmListFilterRaw = getRawFilter(state);
  const searchValue = getKnmListSearchValue(state);

  if (!rawFilter) {
    return null;
  }

  let requestData: IKnmListFilterParams | null = null;

  if (isFilterOn) {
    requestData = searchValue ? { ...rawFilter, searchString: searchValue, version } : { ...rawFilter, version };
  } else {
    requestData = searchValue ? { searchString: searchValue, version, planNum } : { version, planNum };
  }

  return requestData;
};
